import {AbstractModel, JsonObject, JsonProperty} from 'projects/core/src/public-api';

@JsonObject('model.TaskTabsCount')
export class TaskTabsCount extends AbstractModel {

  @JsonProperty(Number, 'taskCompleted')
  taskCompleted?: number;

  @JsonProperty(Number, 'taskIncomplete')
  taskIncomplete?: number;

  @JsonProperty(Number, 'checkitemCommentCompleted')
  checkitemCommentCompleted?: number;

  @JsonProperty(Number, 'checkitemCommentIncomplete')
  checkitemCommentIncomplete?: number;

  @JsonProperty(Number, 'workOrderCompleted')
  workOrderCompleted?: number;

  @JsonProperty(Number, 'workOrderIncomplete')
  workOrderIncomplete?: number;

}

